import { ApolloClient } from "@apollo/client/core";

import { UserBookSerializersUserBook } from "types/serializers";
import { NewUserBookType } from "types/UserBookType";

import {
  updateUserBook as updateUserBookService,
  insertUserBook as insertUserBookService,
  deleteUserBook as deleteUserBookService,
} from "./index";

// UPDATE
export async function updateUserBook({
  id,
  userBook,
  client,
  userDate,
}: {
  id: number;
  userBook: UserBookSerializersUserBook;
  client: ApolloClient<any>;
  userDate?: string;
}) {
  return updateUserBookService({ client, id, userBook, userDate });
}

// INSERT
export async function insertUserBook({
  userBook,
  client,
  userDate,
}: {
  userBook: NewUserBookType;
  client: ApolloClient<any>;
  userDate?: string;
}) {
  return insertUserBookService({ client, userBook, userDate });
}

// Delete
export async function deleteUserBook(id: number, client: ApolloClient<any>) {
  return deleteUserBookService({ client, id });
}
